// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--cAbM8","tag":"_93444fe79c--tag--o2cUZ"};